export { default } from './InstallmentCardContainer';
